import log, { LogContext } from '@utils/logging';
import { createListPath, PagePath } from '@routing/appUrls';
import { useAtom } from 'jotai';
import { currentDocClassAtom } from '@js/store/appAtoms';
import { useNavigate, useLocation } from 'react-router-dom';
import useFeatureFlags from '@hooks/useFeatureFlags';

const useChangeCurrentDocClass = () => {
    const [currentDocClass, setCurrentDocClass] = useAtom(currentDocClassAtom);
    const { featureFlagFileHandlerMultipleDocClasses } = useFeatureFlags();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const changeCurrentDocClass = (docClass: string) => {
        if (docClass === currentDocClass) {
            navigate(createListPath(docClass));
            return;
        }

        setCurrentDocClass(docClass);
        log({
            context: LogContext.CurrentDocClass,
            title: 'Current docClass changed',
            reason: 'User changed docClass',
            data: {
                newDocClass: docClass,
            },
        });

        if (pathname === PagePath.fileHandler && featureFlagFileHandlerMultipleDocClasses) {
            // If the user is on the file handler page, we do not navigate to the list view
            return;
        }

        navigate(createListPath(docClass));
    };

    return changeCurrentDocClass;
};

export default useChangeCurrentDocClass;
